PJQ.app = {
    version: typeof bbVersion !== 'undefined' ? bbVersion : _.uniqueId(),
    module: typeof bbModule !== 'undefined' ? bbModule : null,
    options: {
        cdnUrl: typeof cdnUrl !== 'undefined' ? cdnUrl : null,
        apiUrl: typeof bbApiUrl !== 'undefined' ? bbApiUrl : 'https://api.tm.panteratools.com',
        apiV2Url: typeof bbApiV2Url !== 'undefined' ? bbApiV2Url : 'https://api-v2.panteratools.com',
        fileApiUrl: typeof bbFileApiUrl !== 'undefined' ? bbFileApiUrl : 'https://api.panteratools.com',
        defaultPortalUrl: typeof bbPanteraUrl !== 'undefined' ? bbPanteraUrl : 'https://app.panteratools.com',
        uploadUrl: typeof bbUploadUrl !== 'undefined' ? bbUploadUrl : null,
        isCombinedAssets: typeof bbCombinedAssets !== 'undefined' ? bbCombinedAssets : null,
        isK8: typeof isK8 !== 'undefined' ? isK8 : null,
        isV2Zips: false
    },
    portal: null,
    groups: [],
    readyEvents: [],
    oldRoutes: [],
    routes: [
        {
            title: 'Sign In',
            route: 'signin',
            name: 'signin',
            callback: function () {
                if (!PJQ.app.session.isLoggedIn()) {
                    new PJQ.views.auth.AppSignIn({
                        el: PJQ.app.$el
                    });
                } else {
                    PJQ.app.router.navigate("", {
                        trigger: true
                    });
                }
            }
        },
        {
            title: 'Sign Up',
            route: 'signup',
            name: 'signup',
            callback: function () {
                if (!PJQ.app.session.isLoggedIn()) {
                    new PJQ.views.auth.AppSignUp({
                        el: PJQ.app.$el
                    });
                } else {
                    let rRoot = PJQ.app.router.navigate("", {
                            trigger: true
                        }),
                        accessKey = PJQ.app.session.get('accessKey');
                    if (_.size(accessKey) > 0) {
                        PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
                            if (err != null) {
                                rRoot();
                            }
                        }, this));
                    } else {
                        rRoot();
                    }
                }
            }
        },
        {
            title: 'Sign Up - Free Trial',
            route: 'signup/trial/:subscription',
            name: 'signuptrial',
            callback: function (subscription) {
                let affiliateId = PJQ.helpers.urlHelpers.getQueryParam('affiliateId'),
                    subscriptionId;
                if (_.size(subscription) > 0) {
                    subscriptionId = PJQ.constants.subscriptions.types[subscription.toUpperCase()]
                } else {
                    subscriptionId = null;
                }
                if (!PJQ.app.session.isLoggedIn()) {
                    new PJQ.views.auth.AppSignUp({
                        el: PJQ.app.$el,
                        subscriptionId: subscriptionId,
                        affiliateId: affiliateId
                    });
                } else {
                    // update the trial for the context user automatically if they arent on the free subscription
                    // also don't do this if they are "onAccount"
                    if (!PJQ.app.session.get('onAccount') && subscriptionId > PJQ.constants.subscriptions.types.FREE && PJQ.app.session.subscription.id <= PJQ.constants.subscriptions.types.FREE) {
                        PJQ.app.session.updateTrial(subscriptionId, _.bind(function (data) {
                            if (data == null || data.subscription == null) {
                                PJQ.notifications.notify.errorNotify({
                                    message: 'Encountered an error starting your free trial.  Please contact customer service.'
                                });
                            } else {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Free trial started'
                                });
                            }
                        }, this), _.bind(function () {
                            PJQ.notifications.notify.errorNotify({
                                message: 'Encountered an error starting your free trial.  Please contact customer service.'
                            });
                        }, this));
                    }
                    PJQ.app.router.navigate("", {
                        trigger: true
                    });
                }
            }
        },
        {
            title: 'Documents',
            route: 'documents',
            name: 'documents',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "documents"
                });
            }
        }
    ],
    scrollTo: function (x, y) {
        PJQ.app.$el.find('.nav-content').animate({
            scrollTop: y,
            scrollLeft: x
        }, 1);
    },
    signOutNavigate: function () {
        if (PJQ.app.options.isK8) {
            window.location.href = "/signout";
        } else {
            window.location.href = "/Signout.aspx";
        }
    },
    renderPortalPage: function (page) {
        $('.skin-header').hide();
        PJQ.app.$el.css('top', 0);
        let pageUrl;
        if (PJQ.app.options.isK8) {
            pageUrl = '/static/' + page + '.html'
        } else {
            pageUrl = '/portals/' + PJQ.app.session.get('portalId').toString() + '/' + page + '.html'
        }
        $.ajax({
            url: pageUrl + "?" + PJQ.app.version,
            method: 'GET',
            dataType: 'html',
            success: _.bind(function (html) {
                PJQ.templating.TemplateRenderer.renderTemplate(false, $(html), PJQ.app.$el, null, function (el) {
                    if (_.size(PJQ.app.portal.menuItems) > 0) {
                        PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Portal-Menu'), $('.portal-menu'), {
                            menuItems: PJQ.app.portal.menuItems
                        });
                    }

                    $(el).find('div.module').each(function () {
                        let type = $(this).data('type'),
                            typeSplit = type.split('.'),
                            view = PJQ.views;
                        _.each(typeSplit, function (obj) {
                            view = view[obj];
                        });
                        if (typeof view === 'function') {
                            new view({
                                el: $(this),
                                masterUserId: $(this).data('masterUserId')
                            });
                        }
                    });
                });
            }, this)
        });
    },
    addOldRoutes: function (addRoutes) {
        this.oldRoutes = _.union(addRoutes, this.oldRoutes);
    },
    addRoutes: function (addRoutes) {
        if (PJQ.helpers.objectHelpers.refinedType(addRoutes) !== 'array') {
            addRoutes = [addRoutes];
        }
        this.routes = _.union(addRoutes, this.routes);
    },
    configureSentry: function () {
        //temporarily disable until we have time to actually manage the results
        // if (typeof Sentry === 'object') {
        // 	Sentry.init(
        // 		{
        // 			dsn: 'https://1fd906b1b3524d3ab3b466651b2dda6b@sentry.io/1459517',
        // 			release: PJQ.app.version,
        // 			blacklistUrls: [
        // 				'/DesktopModules/PanteraModuleGlobal/dhtmlx',
        // 				/maps\.google\.com/i
        // 			]
        // 		}
        // 	);
        // }
    },
    configureTokenManager: function () {
        let enabledPortals = [4, 48, 64, 94, 162, 220, 237, 262, 267, 290, 339, 358, 379, 395, 407, 420, 440, 477, 508, 513, 514, 524, 538, 545, 552, 555, 443, 560, 206, 285, 325, 380, 320, 87, 205, 512, 457, 351, 377, 447, 137, 188, 349, 487, 549, 145, 97, 130, 318, 495, 402, 417, 111, 257];
        this.TokenManager = new PJQ.TokenManager({
            accessToken: window.accessToken,
            refreshToken: window.refreshToken,
            expiresOn: _.size(window.accessTokenExpiresOn) > 0 ? new Date(window.accessTokenExpiresOn) : null,
            // enabled: enabledPortals.indexOf(bbPortalId) !== -1 || (new RegExp("://dev[0-9]{0,}.")).test(window.location.href) || (new RegExp("://sandbox.")).test(window.location.href)
            enabled: true
        });
    },
    beforeReady: function () {
        this.configureSentry();

        this.configureTokenManager();

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.userLogin && typeof window.webkit.messageHandlers.userLogin.postMessage === 'function') {
            window.webkit.messageHandlers.userLogin.postMessage({
                sessionId: bbSessionId
            });
        } else if (window.Android && typeof window.Android.userLogin === 'function') {
            window.Android.userLogin(bbSessionId);
        }

        let $hd = $('head');
        $hd.append('<link href="https://fonts.cdnfonts.com/css/nevis" rel="stylesheet">');
        $hd.append('<script src="https://export.dhtmlx.com/gantt/api.js"></script>');
        // $hd.append('<script type="text/javascript" src="https://secure.smart-enterprise-7.com/js/262471.js" ></script><noscript><img alt="" src="https://secure.smart-enterprise-7.com/262471.png" style="display:none;" /></noscript>');

        if (PJQ.app.options.isK8) {
            this.$el = $('.app-container');
        } else {
            this.$el = $('#pjq-main');
        }

        PJQ.helpers.domReadyHelper();

        if (PJQ.app.portal != null && _.size(PJQ.app.portal.pages) > 0) {
            _.each(PJQ.app.portal.pages, _.bind(function (page) {
                // add the portal page route
                PJQ.app.routes.push({
                    title: page.title,
                    route: 'p/' + page.route,
                    name: 'portal_' + page.name,
                    callback: _.bind(function () {
                        this.renderPortalPage(page.name);
                    }, this)
                });
            }, this));

            // check if the current route is not for the app
            // if so, don't bother fetching the session yet
            let isPortalRoute = false,
                hash = window.location.hash.replace('#', '');
            if (_.size(hash) === 0) {
                isPortalRoute = _.findWhere(PJQ.app.portal.pages, {isRoot: true}) != null;
            } else if (hash.indexOf('p/') !== -1) {
                isPortalRoute = _.findWhere(PJQ.app.portal.pages, {route: hash.replace('p/', '')}) != null;
            }
            this.getSession(!isPortalRoute);
        } else {
            this.getSession();
        }

        window.captureOutboundLink = function (category, url) {
            ga('send', 'event', _.size(category) > 0 ? category : 'outbound', 'click', url, {
                'transport': 'beacon',
                'hitCallback': function () {
                }
            });
        }

        this.attachEvents();
    },
    attachEvents: function () {
        let $body = $('body');
        $body.on('click', '.watch-contact-edit', function (e) {
            if (PJQ.app.session.hasPermission('contacts.canView')) {
                let $target = $(e.currentTarget),
                    $badge = $target.closest('.select-contact-container'),
                    id = $target.data('contactId'),
                    ec;
                if (PJQ.app.session.project != null) {
                    ec = new PJQ.models.projectContacts.ProjectContact({
                        id: id,
                        projectId: PJQ.app.session.project.id
                    });
                } else {
                    ec = new PJQ.models.contacts.Contact({
                        id: id
                    });
                }
                new PJQ.views.contacts.BaseEditContactModal({
                    model: ec,
                    project: PJQ.app.session.project,
                    onSave: function () {
                        $badge.find('.company-name').text(ec.get('companyName'));
                        $badge.find('.contact-name').text(ec.get('contactName'));
                    }
                });
            }
        });

        $body.on('click', '.clipboard-input', _.bind(function (e) {
            let $btn = $(e.currentTarget),
                $input = $btn.prev('input');
            if ($input.length === 0) {
                $input = $btn.next('input');
            }
            if ($input.length > 0) {
                navigator.clipboard.writeText($input.val());
                $input[0].select();
                PJQ.notifications.notify.successNotify({
                    message: 'Text copied to clipboard'
                });
            }
        }, this));

        $body.on('click', '.btn-change-sub', _.bind(function (e) {
            new PJQ.views.subscriptions.EditSubscriptionModal({
                preventTrial: $(e.currentTarget).hasClass('no-trial'),
                onSave: _.bind(function (type) {
                    if (!PJQ.app.session.get('onAccount')) {
                        PJQ.helpers.tours.initTour();
                    }
                }, this)
            });
        }, this));

        $body.on('click', '.dropdown-menu a.dropdown-toggle', function (e) {
            if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
            }

            let $subMenu = $(this).next('.dropdown-menu');
            $subMenu.toggleClass('show');

            $(this).closest('.dropdown-menu.show').add($(this).closest('.btn-group.show')).on('hidden.bs.dropdown', function (e) {
                $(this).find('.dropdown-submenu .dropdown-menu').removeClass('show');
            });

            return false;
        });
    },
    lazyLoad: function () {
        if (this.LazyLoad == null && typeof LazyLoad == 'function') {
            this.LazyLoad = new LazyLoad();
        }
        return this.LazyLoad;
    },
    getSession: function (isFetch = true, retryCount = 0) {
        let urlAccessKey = PJQ.helpers.urlHelpers.getQueryParam('accessKey'),
            urlContactGuid = PJQ.helpers.urlHelpers.getQueryParam('cg'),
            windowAccessKey = typeof bbAccessKey !== 'undefined' ? bbAccessKey : null;
        this.session = new PJQ.models.sessions.Session({
            sessionId: typeof bbSessionId !== 'undefined' ? bbSessionId : null,
            masterUserId: typeof bbMasterUserId !== 'undefined' ? bbMasterUserId : null,
            userId: typeof bbUserId !== 'undefined' ? bbUserId : null,
            portalId: typeof bbPortalId !== 'undefined' ? bbPortalId : null,
            contactGuid: _.size(urlContactGuid) > 0 ? urlContactGuid : null,
            accessKey: _.size(urlAccessKey) > 0 ? urlAccessKey : windowAccessKey
        });

        if (isFetch || this.session.get('userId') > 0) {
            this.session.fetch({
                cache: false,
                success: _.bind(_.bind(function () {
                    if ((PJQ.app.options.isK8 || this.session.get('masterUserId') === -1) && this.session.user != null) {
                        this.session.set('masterUserId', this.session.user.get('masterUserId'));
                        this.session.set('userId', this.session.user.get('userId'));
                    }

                    if(this.session.isLoggedIn()){
                        if (_.size(PJQ.helpers.urlHelpers.getQueryParam('paysimple')) > 0) {
                            let companyId = this.session.user.get('companyId');
                            if (companyId > 0) {
                                new PJQ.views.paysimple.SignUpOpenedModal();
                                window.open('https://payments.paysimple.com/SignUp/Start?rid=459&externalId=' + companyId.toString(), '_blank');
                                return;
                            }
                        }

                        let accessToken = PJQ.app.TokenManager.getAccessToken(),
                            refreshToken = PJQ.app.TokenManager.getRefreshToken();
                        if(this.session.get('ownsPortal') && (_.size(accessToken) > 0 || _.size(refreshToken) > 0)){
                            this.session.fetchERPIntegration(_.bind(function (erp) {
                                this.ready();
                            }, this));
                            return;
                        }
                    }

                    this.ready();
                }, this), this),
                error: _.bind(function (model, result) {
                    //Log the error but still continue to ready in case the app doesn't require the session (not likely but still try)
                    //If the status is 0, this means the browser is failing to communicate with the API
                    //Retry 3 times before logging the error if this is the case
                    if (result != null && result.status === 0) {
                        if (retryCount < 3) {
                            retryCount++;
                            this.getSession(true, retryCount);
                        }
                    } else {
                        this.ready();
                    }
                }, this)
            });
        } else {
            this.ready();
        }
    },
    initNavigator: function (options) {
        if (PJQ.app.session.project != null) {
            PJQ.app.session.project.fetchProjectCustomFields(_.bind(function (customFields) {
                if (PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
                    PJQ.app.session.project.customFields = new PJQ.collections.projects.ProjectCustomFields(_.filter(customFields.models, function (customField) {
                        if (customField.get('isVisibleInRSVP'))
                            return customField;
                    }));
                    PJQ.app.session.project.customFields.isFetched = true;
                }

                if (PJQ.app.navigator != null) {
                    PJQ.app.navigator.remove();
                }
                $('a.nav-item').off();
                PJQ.app.navigator = new PJQ.views.nav.AppNavigator(_.defaults(options ? options : {}, {
                    el: PJQ.app.$el
                }));
            }, this));
        } else {
            if (PJQ.app.navigator != null) {
                PJQ.app.navigator.remove();
            }
            PJQ.app.navigator = new PJQ.views.nav.AppNavigator(_.defaults(options ? options : {}, {
                el: PJQ.app.$el
            }));
        }
    },
    attachReadyEvent: function (func) {
        this.readyEvents.push(func);
    },
    ready: function () {
        if (PJQ.modules.pjqProjectWall != null && !this.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_PROJECT_WALL)) {
            if (PJQ.app.module === PJQ.constants.modules.PROJECTWALLADMIN) {
                PJQ.app.addOldRoutes(PJQ.modules.pjqProjectWall.oldRoutes);
            }
            PJQ.app.addRoutes(PJQ.modules.pjqProjectWall.routes);
        }

        this.router = new PJQ.routers.BaseRouter();
        if (!Backbone.history.start()) {
            this.router.empty();
        }
    }
};

PJQ.views.AppView = class {
    constructor($el) {
        this.$el = $el;
    }

    renderView(view, options) {
        this.removeActiveView();

        let $elInner = $('<div>');
        this.$el.append($elInner);
        this.$el = $elInner;
        $elInner.addClass('p-3 ht-100');

        this.view = new view(_.defaults(options ? options : {}, {
            el: this.$el
        }));

        return this.view;
    }

    //Profile outer view
    renderProfile(key, tab) {
        if (this.view && this.view instanceof PJQ.views.profile.CompanyProfile && this.view.model.id === key) {
            this.view.activateTab(tab);
        } else {
            if (!(this.view instanceof PJQ.views.profile.CompanyProfile)) {
                this.removeActiveView();
            }
            let self = this,
                profile = new PJQ.models.profile.CompanyProfile({
                    profileKey: key
                });
            profile.fetch({
                success: function () {
                    //We still want to make sure that the key doesn't match what is in the view already just in case this is a user looking at their own profile
                    if (this.view && this.view instanceof PJQ.views.profile.CompanyProfile && this.view.model.id === profile.id) {
                        this.view.activateTab(tab);
                    } else {
                        self.removeActiveView();
                        self.renderView(PJQ.views.profile.CompanyProfile, {
                            el: self.$el,
                            model: profile,
                            activateTab: tab
                        });
                    }
                }
            });
        }
    }

    //Screenings outer view
    renderScreeningDashboard() {
        if (this.view && this.view instanceof PJQ.views.screenings.ScreeningDashboard) {

        } else {
            this.removeActiveView();
            let self = this,
                clients = new PJQ.collections.screenings.ScreeningClients(null, {
                    contact: PJQ.app.session.contact,
                    masterUserId: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId')
                });
            clients.fetch({
                success: function () {
                    self.renderView(PJQ.views.screenings.ScreeningDashboard, {
                        collection: clients
                    });
                },
                error: function (model, result) {
                    new PJQ.logging.Debug(PJQ.logging.LoggingActions.PJQPROFILE_GET_SCREENINGS, {
                        model: model,
                        result: result
                    });
                }
            });
        }
    }

    renderPhotoViewer(options) {
        this.photoViewer = new PJQ.views.photos.PhotoViewer(_.extend(options, {
            onClose: _.bind(function () {
                if (this.photoViewer) {
                    this.photoViewer = null;
                }
            }, this)
        }));
    }

    removeActiveView() {
        if (this.view) {
            this.view.remove();
            this.view = null;
        }
    }
};
